import {
    all,
    call,
    delay,
    fork,
    put,
    race,
    select,
    take
} from "redux-saga/effects";
import {getApiUrl, getSApiUrl} from "../../config/helper";
import {getAffiches, getCustomer, getLocation, getLocal} from "../../selectors";
import {
    AFFICHES_RECEIVED,
    AGENDA_RECEIVED,
    BUTTONS_RECEIVED,
    FETCH_ERROR,
    MOBILITE_RECEIVED,
    NEWS_RECEIVED,
    POLL_START,
    POLL_STOP
} from "../actions";

function* fetchAffiches() {
    const apiUrl = getApiUrl();
    const cAffiches = yield select(getAffiches);
    const customer = yield select(getCustomer);
    const local = yield select(getLocal);

    let url;
    if (local === "2") {
        url = 'https://ngtech-cache-dev.sm4rt.design/provider/sliders/publilux/';
    } else {
        url = `${apiUrl}api/export/forms/3cc1308d-c5d2-4b10-9de4-e1b7ab0f84e5/json`;
        //url = `config/test.json`;
    }

    try {
        const affiches = yield fetch(url).then((response) => response.json());
        if (JSON.stringify(affiches) !== JSON.stringify(cAffiches)) {
            yield put({ type: AFFICHES_RECEIVED, affiches: affiches });
        }
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* fetchButtons() {
    const apiUrl = getApiUrl();
    const customer = yield select(getCustomer);

    //const blacklist = ['diekirch', 'erpeldange', 'rumelange'];
    //if (blacklist.includes(customer)) return false;

    try {
        const buttons = yield fetch(
            `${apiUrl}api/export/forms/b487d720-a515-4283-a0b8-be8c6771f80a/json`
        ).then((response) => response.json());
        if (buttons && buttons.length > 0) {
            if (buttons[0][customer] === true) {
                yield put({ type: BUTTONS_RECEIVED, buttons: buttons });
            } else {
                yield put({ type: BUTTONS_RECEIVED, buttons: [] });
            }
        }
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* fetchNews() {
    const customer = yield select(getCustomer);
    const apiUrl = getSApiUrl();

    try {
        const news = yield fetch(`${apiUrl}/news2?city=${customer}`).then(
            (response) => response.json()
        );

        yield put({ type: NEWS_RECEIVED, news: news });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* fetchMobilite() {
    const apiUrl = getSApiUrl();
    const location = yield select(getLocation);
    const customer = yield select(getCustomer);

    try {
        const mobilite = yield fetch(
            "https://ng-mobiliteit-api-and-cache.sm4rt.design/busstop/json/NG/456fdffsdihlfahdskvalkv98s65d/"+location.id+"/"+location.direction
        ).then((response) => response.json());

        yield put({ type: MOBILITE_RECEIVED, mobilite: mobilite });
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* fetchAgenda() {
    const apiUrl = getSApiUrl();
    const customer = yield select(getCustomer);

    try {
        const agenda = ""
        if ( customer === "mertert" ){
            const agenda = yield fetch(`${apiUrl}/events?customer=${customer}`).then(
                (response) => response.json()
            );
            yield put({ type: AGENDA_RECEIVED, agenda: agenda});
        }
        else{
            const agenda = yield fetch(`${apiUrl}/events2?city=${customer}`).then(
                (response) => response.json()
            );
            yield put({ type: AGENDA_RECEIVED, agenda: agenda });
        }
    } catch (error) {
        yield put({ type: FETCH_ERROR, error });
    }
}

function* watchStandardData() {
    while (true) {
        try {
            yield all([
                fork(fetchAffiches),
                fork(fetchButtons),
                fork(fetchNews),
                fork(fetchAgenda),
            ]);
        } catch (e) {
            console.error("Standard Data Error:", e);
        }
        yield delay(3600000); // every 1 hour
    }
}

function* watchFastData() {
    while (true) {
        try {
            yield all([
                fork(fetchMobilite)
            ]);
        } catch (e) {
            console.error("Fast Data Error:", e);
        }
        yield delay(60000); // every 1 minutes
    }
}

function* fetchData() {
    yield all([
        fork(watchStandardData),
        fork(watchFastData)
    ]);
}

function* fetchDataWatcher() {
    while (true) {
        yield take(POLL_START);
        yield race([call(fetchData), take(POLL_STOP)]);
    }
}

export default fetchDataWatcher;
